const LocalStorage = {
  User: "user",
  productToBuy: "productToBuy",
};

export default LocalStorage;
